import { render, staticRenderFns } from "./CardTable.vue?vue&type=template&id=708cdb77"
import script from "./CardTable.vue?vue&type=script&lang=ts"
export * from "./CardTable.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports